import React, { useState, useEffect } from "react";
import ApiClient from "../services/api-client"
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import ActionsRenderer from "../components/aggrids/aggrid-cell-renderers/actions-renderer";
import useStore from "../hooks/useStore";



export default function ProductCategorySearch() {

    const [rowData, setRowData] = useState([]);
    const navigate = useNavigate();
    const [gridApi, setGridApi] = useState(null);
    const { t } = useTranslation();
    const pagination = true;
    const paginationPageSize = 10;

    useEffect(() => {
         var companyId = useStore.getState().selectedCompany.id;

        ApiClient.getCompanyProductCategories(companyId).then(
            response => {
                console.log(response.data)
                setRowData(response.data);

            },
            error => {
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        );
    }, []);

    const onGridReady = params => {
        setGridApi(params.api);
    };

    const onQuickFilterChanged = e => {
        gridApi.setQuickFilter(e.target.value);
    };


    const goTo = id => {
        navigate("/productCategory/" + id);
    }

    const hangleEdit = (params) => {
        navigate("/productCategory/" + params.data.id);
    }

    return (
        <div className="container" style={{ padding: 4 }}>
            <header className="jumbotron">
                <div className="row">
                    <div className="col-md-6">
                        <h5 className="subtitle skin">{t("classificationsOfProductsSearch")}</h5>
                    </div>
                    <div className="col-md-6">
                        <div className="addmodelBtnContainer">
                            <button className="btn btn-skin" href="" onClick={function () { return navigate("/productCategory"); }}>
                                {t("classificationsOfProductsAdd")}  <i className="fa  fa-plus"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </header>
            <br></br>
            <div className="row">
                <div className="col-md-12">
                    <div className="alert alert-primary small-info" role="alert">
                        <p >{t("productCategoriesInfo")}</p>
                    </div>
                </div>
            </div>
            <div style={{ width: '100%', height: '100%' }}>
                <div className="row">
                    <div className="offset-md-4 col-md-4">
                        <p className="text-center">
                            <input placeholder={t('Search')} className="form-control" onChange={onQuickFilterChanged} />
                        </p>
                    </div>

                </div>

                <div
                    id="myGrid"
                    style={{
                        height: '100%',
                        width: '100%',
                    }}
                    className="ag-theme-alpine-dark"
                >
                    <div className="ag-theme-alpine" style={{ height: 300, width: '100%' }}>
                        <AgGridReact
                            pagination={pagination}
                            paginationPageSize={paginationPageSize}
                            onGridReady={onGridReady}
                            style={{ width: '100%', height: '100%;' }}
                            onRowDoubleClicked={(e) => goTo(e.data.id)}
                            rowData={rowData}
                            frameworkComponents={{
                                actionsRenderer: ActionsRenderer,
                            }}
                            columnDefs={[
                                { field: "name", flex: 3, headerName: t("Name"), sortable: true, filter: "agTextColumnFilter" },
                                { field: "action", flex: 1, maxWidth: 100, minWidth: 40, headerName: t("Actions"), cellRenderer: ActionsRenderer, cellRendererParams: { action: "edit", hangleEdit: hangleEdit } }
                            ]}
                            overlayNoRowsTemplate={
                                '<span style="padding: 10px;  color:#013289">' + t('noEntries') + '</span>'
                            }
                        >
                        </AgGridReact>
                    </div>

                </div>
            </div>
        </div>
    );
}


